import {getDrugTradeNames} from '@/modules/drug-catalog/functions'
import {useGetActiveSubstanceDrug, useGetActiveSubstanceDrugActivities} from '@/modules/drug-catalog/substances/api'
import {DrugCatalogItem, EventLog, TradeName} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  activeSubstanceDrug: DrugCatalogItem
  tradeNames: TradeName[]
  activities?: EventLog[]
}

interface Props extends PropsWithChildren {
  activeSubstanceDrug: DrugCatalogItem
}

const ActiveSubstanceDrugContext = createContext<State>({} as State)

export function ActiveSubstanceDrugProvider({children, activeSubstanceDrug: initialDrug}: Props) {
  const [activeSubstanceDrug] = useGetActiveSubstanceDrug(initialDrug.id)
  const [activities] = useGetActiveSubstanceDrugActivities(initialDrug.id)

  const drug = activeSubstanceDrug || initialDrug
  const tradeNames = getDrugTradeNames(drug)

  return (
    <ActiveSubstanceDrugContext.Provider value={{activeSubstanceDrug: drug, tradeNames, activities}}>
      {children}
    </ActiveSubstanceDrugContext.Provider>
  )
}

export function useActiveSubstanceDrugContext() {
  return useContext(ActiveSubstanceDrugContext)
}
